import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';
import JisButton from '../components/controls/jisButton';
import CaseSearch from '../components/core/case_search';
import JisEmptyList from '../components/controls/emptylist';
import Pagenated from '../components/pagenated';

import wordicon from '../assets/ms_word.png';
import excelicon from '../assets/ms_excel.png';
import pdficon from '../assets/pdf.png';

function MyCases() {
     const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState({});
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
     
      useEffect(() => {
          onLoad();       
    }, []);

/*      useEffect(() => {
          
          onSearch(sear);     
    }, [search]); */

    useEffect(() => {
      if(!isSearch){
        onLoad(); 
      }else{
        onSearch(search);
      }
                
    }, [pageIndex,pageSize, search]);

  const onSearch=async(sear)=>{ 
           
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/get-my-cases/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.cases)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }

const onLoad= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/get-my-cases/${pageIndex}/${pageSize}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setCases(data.items)
               if(pageIndex==0){
                setCount(data.totalCount)
               }
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
    const onContinue=(caseid)=>{
        navigate(`/case-details/${caseid}`)
    }
      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

const onDirectSearch=(sear)=>{
   setSearch(sear)       ;
   setIsSearch(true);
  setPageIndex(0);
}
  const onDownload = async (dtype) => {
     const url = `${Constants.apiUrl}/report/my-case-download/${dtype}`;
 
     // Map doctype to MIME and extension
     const typeMap = {
         excel: {
             mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
             ext: "xlsx",
         },
         msword: {
             mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
             ext: "docx",
         },
         pdf: {
             mime: "application/pdf",
             ext: "pdf",
         },
     };
 
     try {
         setLoading(true);
         const resp = await fetch(url, {
             method: "POST",
             body: JSON.stringify(search),
             headers: {
                 "Content-Type": "application/json",
                 Authorization: `Bearer ${token}`,
             },
         });
 
         if (!resp.ok) throw new Error("Failed to download");
 
         const blob = await resp.blob();
         const downloadUrl = window.URL.createObjectURL(blob);
         const link = document.createElement("a");
         link.href = downloadUrl;
         link.download = `report.${typeMap[dtype].ext}`; // Fixed filename
         link.click();
         window.URL.revokeObjectURL(downloadUrl); // Clean up
         setLoading(false);
     } catch (error) {
         setLoading(false);
         console.error("Download failed:", error);
     }
 };

  return (
    <div>
     
      <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} />
{cases?.length==0 && <JisEmptyList/>}
{cases?.length>0 && <>
<div className='exportdiv'>
  <img src={wordicon} onClick={()=>onDownload('msword')}/>
  <img src={excelicon} onClick={()=>onDownload('excel')} />
  <img src={pdficon} onClick={()=>onDownload('pdf')}/>
</div>
<div className='table'>
  <div class="section-cases">
  <span>My Cases </span><span className='total'>{count}</span>
</div>
      <table class="case-table">
  <thead>
    <tr>
      <th>Suit Number</th>
      <th>Case Title</th>
      <th>Filing Type</th>
      <th>Classification</th>
      <th>Date Filed</th>
      <th>Status Level</th>
  
      <th>Details</th>
    </tr>
  </thead>
  <tbody>
     {cases?.map((opt, index) => (
       <tr key={index}>
      <td  style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.caseNumber?? opt.referenceNumber} </td>
      <td>{opt.caseTitle}</td>
       <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
      <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
      <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
       <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
      <td><JisButton variant='plain' onClick={()=>onContinue(opt.caseId)}>View</JisButton></td>
    </tr>
    ))} 
    


  </tbody>
</table>
{cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
</div></>}
<BackLoader open={loading} />

    </div>
  );
}

export default MyCases;